import { Stack, Typography, Box, Snackbar, Alert } from "@mui/material";

import { useState, useEffect } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";

import { ReactComponent as IconTrash } from "../../images/iconTrash.svg";

import { ReactComponent as IconWallet } from "../../images/iconWallet.svg";

import {
  dadosIniciais,
  prescricaoMedicamentos,
  ventilacaoNaoInvasivaDuracaoOptions,
  traqueostomiaProcedimentoOptions,
  multidisciplinaridadeTipoOptions,
  statusCognitivoOptions,
  tipoProcedimentoOptions,
  simOuNaoOptions,
  presenteAusenteOptions,
  musculaturaFacialOptions,
  reflexoNauseosoOptions,
  masseterOptions,
  veloPalatinoOptions,
  tonusMuscularOptions,
  reflexoOptions,
  avaliacaoSegmentarOptions,
  examesPredefinidosOptions,
  linguaMovimentacaoOptions,
  linguaAtrofiaOptions,
  fasciculacoesOndeOptions,
  disfuncaoAutonomicaOptions,
  diagnosticoEhELAOptions,
  classificacaoKingsCollegeOptions,
  causaOptions,
  localDeInicioOptions,
  fenotipoDeInicioOptions,
  examesPredefinidosList,
  periodoTratamentoOptions,
  sinaisSintomasList,
} from "./dadosIniciais";
import {
  requestAnamneseNeurologica,
  requestAnamneseDadosGerais,
  requestExameNeurologicoNervosCranianos,
  requestExameNeurologicoMotor,
  requestExameNeurologicoSensibilidade,
  requestDiagnosticoELA,
  requestExamesEProcedimentos,
  requestPrescricaoMedicamento,
  requestCondutaConclusaoEncaminhamentos,
} from "../../services/cadastroService";
import api from "../../services/api";
import { formatDateISO8601 } from "../../utils/formatarData";
import { diferencaDatasEmMeses } from "../../utils/diferencaEntreDatasMeses";
import { gerarIdentificador } from "../../utils/gerarIdentificadorPaciente";
import { getDadosRegistro } from "../../services/getRegistroApi";
import CardPaciente from "../../components/CardPaciente";
import InserirDadosRegistro from "./inserirDadosRegistro";
import InserirRespostasSalvas from "./inserirRespostasSalvas";
import inserirMedicamentosSalvos from "./inserirMedicamentosSalvos";
import inserirExamesSalvos from "./inserirExamesSalvos";
import ButtonGoBack from "../../components/Buttons/outlinedGoback";
import TimerComponent from "../../components/Timer";
import ModalDialogs from "../../components/ModalDialogs";
import AnamneseNeurologica from "./modulos/AnamneseNeurologica";
import ExameNeurologico from "./modulos/ExameNeurologico";
import ExamesProcedimentos from "./modulos/Examesprocedimentos";
import DiagnosticoEla from "./modulos/DiagnosticoEla";
import PrescricaoMedicamentos from "./modulos/PrescricaoMedicamentos";
import Condutas from "./modulos/Conduta";
import Loading from "../../components/Loading/index";
import { getItemDecrypt } from "../../utils/cryptoData";
import AnamneseGeral from "./modulos/AnamneseGeral";
import dayjs from "dayjs";
const styles = {
  title: {
    fontWeight: "300",
    fontSize: "32px",
    lineHeight: "25px",
    color: "#063F5E",
  },
  formTitle: {
    fontFamily: "Nunito",
    fontSize: "26px",
    fontWeight: 600,
    lineHeight: "35px",
    letterSpacing: "0em",
    textAlign: "left",
    color: "#063F5E",
  },
  subtitle: {
    fontFamily: "Nunito",
    fontSize: "20px",
    fontWeight: 500,
    lineHeight: "27px",
    color: "#737373",
  },
};

let escalaFuncional;
let timeEscala;
let id_consulta;
let id_consulta_evolucao;

let isConsultaRotina = window.location.href.includes("consulta-rotina");

export default function PrimeiraConsulta() {
  const navigate = useNavigate();
  const { id } = useParams();
  const location = useLocation();
  const queryString = location.search;
  const params = new URLSearchParams(queryString);
  const isMultidisciplinar = params.get("multidisciplinar") === "true";

  const [snackbar, setSnackbar] = useState(null);
  const [substanciaList, setSubstanciaList] = useState([]);
  const [medicamentosList, setMedicamentosList] = useState([]);
  const [medicamentos, setMedicamentos] = useState([]);
  const [apresentacaoList, setApresentacaoList] = useState([]);
  const [dadosIniciaisState, setDadosIniciaisState] = useState(dadosIniciais);
  const [prescricaoMedicamentosState, setPrescricaoMedicamentosState] =
    useState(prescricaoMedicamentos);
  const [dataPrimeiroSintoma, setDataPrimeiroSintoma] = useState("");
  const [value, setValue] = useState(0);
  const [pesoHabitual, setPesoHabitual] = useState();
  const [loading, setLoading] = useState(true);
  const [CIDList, setCIDList] = useState([]);
  const [time, setTime] = useState(0);
  const [isRunning, setIsRunning] = useState(true);
  const [open, setOpen] = useState(false);
  const [openFinalizar, setOpenFinalizar] = useState(false);
  const [openSalvar, setOpenSalvar] = useState(false);
  const [openCancelar, setOpenCancelar] = useState(false);
  const [openRemoverMedicamento, setOpenRemoverMedicamento] = useState(false);
  const [idConsultaEvolucao, setIdConsultaEvolucao] = useState(0);
  const [consultaAgendada, setConsultaAgendada] = useState(null);

  const [expanded, setExpanded] = useState(false);

  const handleChangePanel = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    setOpenSalvar(false);
    setOpenFinalizar(false);
    setOpenCancelar(false);
    setOpenRemoverMedicamento(false);
  };
  const [removerMedicamento, setRemoverMedicamento] = useState({});
  const [editarMedicamento, setEditarMedicamento] = useState({});
  const [modoEdicao, setModoEdicao] = useState(false);
  const [textoBotaoMedicamento, setTextoBotaoMedicamento] = useState(
    "Adicionar novo medicamento +"
  );
  const [atualizarEscalaFuncional, setAtualizarEscalaFuncional] =
    useState(false);

  const handleFinalizar = () => {
    let camposObrigatorios = [
      dadosIniciaisState.traquestomia,
      dadosIniciaisState.gastrostomia,
      dadosIniciaisState.tecnologiaComunicacao,
      dadosIniciaisState.usoCadeiraDeRodas,
      dadosIniciaisState.multidisciplinar,
      dadosIniciaisState.diagnosticoEhELA,
    ];

    if (dadosIniciaisState.diagnosticoEhELA === "50") {
      camposObrigatorios = [
        ...camposObrigatorios,
        dadosIniciaisState.dataDiagnosticoELA,
        dadosIniciaisState.classificacaoKingsCollege,
        dadosIniciaisState.escalaFuncional,
        dadosIniciaisState.velocidadeDeProgressao,
        dadosIniciaisState.causaELA,
        dadosIniciaisState.localDeInicio,
        dadosIniciaisState.fenotipoDeInicio,
      ];
    }
    if (dadosIniciaisState.diagnosticoEhELA === "51") {
      camposObrigatorios = [
        ...camposObrigatorios,
        // dadosIniciaisState.sugestaoDiagnostico,
      ];
    }

    let falhou = false;

    for (const campo of camposObrigatorios) {
      if (campo === "") {
        falhou = true;
        alert("Existem campos obrigatórios que não foram preenchidos");
        return;
      }
    }

    if (!falhou) {
      handleSubmit("salvar-tudo", true);
      setOpen(false);
    }
  };

  const handleCancelarConsulta = () => {
    const CANCELADA = 4;

    atualizaStatusConsulta(idConsultaEvolucao, CANCELADA, vinculo.id);

    handleRedirect();
  };

  const homeIn = () => {
    navigate("/home");
  };

  const Resumo = () => {
    navigate(`/pacientes/resumo-consulta/${idConsultaEvolucao}`);
  };

  const handleRedirect = () => {
    navigate(`/pacientes/prontuario/${id}`);
  };

  useEffect(() => {
    let intervalId;
    if (isRunning) {
      intervalId = setInterval(() => setTime(time + 1), 1000);
    }
    return () => clearInterval(intervalId);
  }, [isRunning, time]);

  const hours = Math.floor(time / 3600); // Calcula as horas
  const minutes = Math.floor((time / 60) % 60); // Calcula os minutos corretamente
  const seconds = Math.floor(time % 60); // Calcula os segundos

  const startAndStop = () => {
    setIsRunning(!isRunning);
  };

  let vinculo = getItemDecrypt("vinculo_ativo");
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    dadosIniciais.idPaciente = id;
    dadosIniciais.idVinculo = vinculo.id;
    isConsultaRotina = window.location.href.includes("consulta-rotina");
    setDadosIniciaisState((prevState) => ({
      ...prevState,
      idPaciente: id,
      idVinculo: vinculo.id,
      nu_consulta: isConsultaRotina ? 2 : 1,
      isMultidisciplinar: isMultidisciplinar,
    }));
    fecthData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [window.location.href]);

  const fecthData = async () => {
    try {
      setLoading(true);

      const rotaValida = await validaRota();
      const rotaValidaConsulta = await validaRotaConsulta();

      await getDadosPaciente();
      // inserir validacao
      if (rotaValida && rotaValidaConsulta) {
        await Promise.all([
          iniciarPrimeiraConsulta(),
          getPeso(),
          getDataPrimeiroSintoma(),
          getSubstanciaMedicamentos(),
          getCIDList(),
        ]);
      }

      verificarEscalaFuncional();
    } catch (error) {
      console.error("Ocorreu um erro:", error);
      // setSnackbar({
      //   children:
      //     "Erro ao tentar conectar-se ao servidor. Por favor, tente novamente mais tarde.",
      //   severity: "error",
      // });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setPrescricaoMedicamentosState(prescricaoMedicamentosState);
  }, [prescricaoMedicamentosState]);

  const getRespostasAnaminese = async (id_consulta) => {
    try {
      if (!id_consulta || id_consulta === "") {
        return [];
      }
      const { data } = await api.get(`/anaminese/${id_consulta}/`);

      if (data.hasOwnProperty("error")) {
        console.log("Erro ao buscar anaminese:", data.error);
        return [];
      }
      return data.respostas;
    } catch (error) {
      console.error("Erro ao buscar respostas:", error);
      return [];
    }
  };

  const iniciarPrimeiraConsulta = async () => {
    try {
      const respostasRecorrentes = await getRespostasRecorrentes();

      if (!isMultidisciplinar) {
        const response = await api.post("/consulta/", {
          data: {
            id_paciente: parseInt(id),
            id_vinculo: vinculo.id,
            nu_consulta: isConsultaRotina ? 2 : 1,
            respostas: respostasRecorrentes.map(({ idPergunta, resposta }) => ({
              pergunta: idPergunta,
              resposta: [207, 208].includes(idPergunta) ? "" : resposta,
            })),
          },
        });

        if (response.data?.error) throw new Error();

        id_consulta_evolucao = response.data.consultaEvolucao.co_id;
        id_consulta = response.data.idConsulta;
        setIdConsultaEvolucao(id_consulta_evolucao);
      }

      const respostasAnaminese = await getRespostasAnaminese(id_consulta);

      const respostasCombinadas = [
        ...respostasRecorrentes,
        ...respostasAnaminese,
      ];
      InserirRespostasSalvas(respostasCombinadas, dadosIniciais, true);

      setDadosIniciaisState({
        ...dadosIniciais,
        idPaciente: id,
        idVinculo: vinculo.id,
        nu_consulta: isConsultaRotina ? 2 : 1,
        id_consulta: id_consulta,
        id_consulta_evolucao: id_consulta_evolucao,
        isMultidisciplinar: isMultidisciplinar,
      });
    } catch (error) {
      console.error("Ocorreu um erro Iniciar consulta:", error);
      alert(error);
      setSnackbar({
        children:
          "No momento, não é possível cadastrar os dados da consulta. Por favor, tente novamente mais tarde.",
        severity: "error",
      });
    }
  };

  const verificarEscalaFuncional = () => {
    localStorage.setItem("novaEscalaFuncional", "");
    escalaFuncional = localStorage.getItem("novaEscalaFuncional");
    timeEscala = setInterval(() => {
      if (escalaFuncional !== localStorage.getItem("novaEscalaFuncional")) {
        setAtualizarEscalaFuncional(true);
        escalaFuncional = localStorage.getItem("novaEscalaFuncional");
        dadosIniciaisState.escalaFuncional = escalaFuncional;
      }
    }, 2000);
    return () => {
      clearInterval(timeEscala);
    };
  };

  const checkAppointment = async (id, numeroConsulta) => {
    try {
      const { data } = await api.get(`/check-consulta`, {
        params: {
          id_paciente: id,
          nu_consulta: numeroConsulta,
        },
      });
      return data?.consulta || null;
    } catch (error) {
      console.error(`Erro ao verificar consulta ${numeroConsulta}:`, error);
      return null;
    }
  };

  const getConsultaAgendada = async () => {
    try {
      const { data } = await api.get(`agenda-paciente/${id}`, {
        params: {
          is_paciente: true,
          status: "1,2",
          data: dayjs().format("YYYY-MM-DD"),
        },
      });
      if (data.length > 0) {
        const response = data[0];
        if (response) {
          const consultaEvo = response.consultas_evoloucao.find(
            (consulta) => consulta.id_vinculo === vinculo.id
          );
          if (!consultaEvo) {
            setSnackbar({
              children:
                "Não existe consulta agendada para hoje. Vocé sera redirecionado para o Prontuário do paciente.",
              severity: "error",
            });
            setTimeout(() => {
              navigate(`/pacientes/prontuario/${id}`);
            }, 5000);
            return false;
          }
          id_consulta = response.id;
          id_consulta_evolucao = consultaEvo.co_id;
          setConsultaAgendada(response);
          setIdConsultaEvolucao(consultaEvo.co_id);
          setDadosIniciaisState({
            ...dadosIniciais,
            id_consulta: response.id,
            id_consulta_evolucao: consultaEvo.co_id,
            isMultidisciplinar: true,
          });
          atualizaStatusConsulta(consultaEvo.co_id, 2, vinculo.id);

          return true;
        }
      }
      setSnackbar({
        children:
          "Não existe consulta agendada para hoje. Você sera redirecionado para o Prontuário do paciente.",
        severity: "error",
      });
      setTimeout(() => {
        navigate(`/pacientes/prontuario/${id}`);
      }, 5000);

      return false;
    } catch (error) {
      console.error("Ocorreu um erro:", error.message);
      return false;
    }
  };

  async function validaRotaConsulta() {
    try {
      if (!isConsultaRotina) {
        const firstAppointment = await checkAppointment(id, 1);

        if (firstAppointment) {
          if (firstAppointment.status === 3) {
            navigate(`/pacientes/consulta-rotina/${id}`);
            return false;
          }
        }
        const response = await api.post("/historico-consultas/", {
          data: {
            id_paciente: parseInt(id),
            id_estabelecimento: null,
            id_categoria: null,
            id_profissional: null,
            id_perfil: null,
            data_inicial: null,
            data_final: null,
          },
        });

        if (response.data.consultas.length > 0) {
          navigate(`/pacientes/consulta-rotina/${id}`);
          return false;
        }
        if (isMultidisciplinar) {
          const consultaAgendada = await getConsultaAgendada();
          return consultaAgendada;
        }
        return true;
      } else {
        if (isMultidisciplinar) {
          const consultaAgendada = await getConsultaAgendada();
          return consultaAgendada;
        } else {
          return true;
        }
      }
    } catch (error) {
      console.error("Error ao validar consulta:", error.message);
      setSnackbar({
        children: "Erro ao validar consulta. Tente novamente mais tarde.",
        severity: "error",
      });
      return false;
    }
  }

  const validaRota = async () => {
    try {
      //Se profissional é neurologista, o retorno da requisição é true
      //Caso contrário, é false
      const { data } = await api.post(`/checar-perfil-profissional/`, {
        id_vinculo: vinculo.id,
      });

      if (!data) {
        navigate(`/pacientes/consulta-demais-profissionais/${id}`);
        return false;
      }
      return true;
    } catch (error) {
      console.error("Erro ao validar perfil:", error.message);
      setSnackbar({
        children: "Erro ao validar perfil. Tente novamente mais tarde.",
        severity: "error",
      });
      return false;
    }
  };

  async function getCIDList() {
    try {
      const { data } = await api.get("/buscacid/");

      setCIDList(data.cids);
    } catch (error) {
      console.error("Ocorreu um erro:", error.message);
    }
  }

  async function getRespostasPrimeiraConsulta() {
    try {
      const { data } = await api.post("respostas-consulta", {
        id_paciente: id,
      });
      return data;
    } catch (error) {
      console.error("Ocorreu um erro:", error.message);
    }
  }

  async function getRespostasRecorrentes() {
    try {
      const { data } = await api.post("respostas-consulta", {
        id_paciente: id,
        filter_questions: true,
      });
      return data;
    } catch (error) {
      console.error("Ocorreu um erro:", error.message);
    }
  }

  async function getMedicamentosPrimeiraConsulta() {
    try {
      const { data } = await api.post("medicamentos-consulta", {
        id_paciente: id,
        id_vinculo: vinculo.id,
      });

      return data;
    } catch (error) {
      console.error("Ocorreu um erro:", error.message);
    }
  }

  async function getExamesPrimeiraConsulta() {
    try {
      const { data } = await api.post("exames-consulta", {
        id_paciente: id,
        id_vinculo: vinculo.id,
      });

      return data;
    } catch (error) {
      console.error("Ocorreu um erro:", error.message);
    }
  }

  async function getDadosPaciente() {
    try {
      const { data } = await api.get(`/dadospaciente/${id}`);
      const identificador = gerarIdentificador(data);
      const respostas = await getRespostasPrimeiraConsulta();

      const [medicamentosSalvos, examesSalvos, dadosPaciente] =
        await Promise.all([
          getMedicamentosPrimeiraConsulta(),
          getExamesPrimeiraConsulta(),
          getDadosRegistro(identificador),
        ]);

      if (dadosPaciente && respostas.length === 0) {
        InserirDadosRegistro(dadosPaciente, setDadosIniciaisState);
      }
      if (respostas.length !== 0) {
        InserirRespostasSalvas(respostas, dadosIniciaisState, false);
      }

      if (medicamentosSalvos.length !== 0) {
        inserirMedicamentosSalvos(medicamentosSalvos, setMedicamentos);
      }

      if (examesSalvos.length !== 0) {
        inserirExamesSalvos(examesSalvos, dadosIniciaisState);
      }
    } catch (error) {
      console.error("Ocorreu um erro:", error.message);
    }
  }

  useEffect(() => {
    if (
      dadosIniciaisState.dataDiagnosticoELA !== "" &&
      dadosIniciaisState.escalaFuncional !== ""
    ) {
      let atrasoDiagnostico = diferencaDatasEmMeses(
        dataPrimeiroSintoma,
        dadosIniciaisState.dataDiagnosticoELA
      );

      let velocidadeProgressao = 0;
      if (atrasoDiagnostico >= 1) {
        velocidadeProgressao =
          (48 - parseInt(dadosIniciaisState.escalaFuncional)) /
          atrasoDiagnostico;
      }

      setDadosIniciaisState((prevState) => ({
        ...prevState,
        velocidadeDeProgressao: velocidadeProgressao.toFixed(2),
      }));
    }
  }, [
    dadosIniciaisState.dataDiagnosticoELA,
    dadosIniciaisState.escalaFuncional,
    dataPrimeiroSintoma,
  ]);

  async function getDataPrimeiroSintoma() {
    try {
      const { data } = await api.post("/pegar-resposta", {
        id_paciente: id,
        id_pergunta: 6,
      });

      const dataFormatada = formatDateISO8601(data);
      setDataPrimeiroSintoma(dataFormatada);
    } catch (error) {
      console.error("Ocorreu um erro:", error.message);
    }
  }

  async function getPeso() {
    try {
      const { data } = await api.post("/pegar-resposta", {
        id_paciente: id,
        id_pergunta: 53,
      });

      if (data !== "") {
        setPesoHabitual(parseFloat(data.replace(",", ".")));
      } else {
        const { data } = await api.post("/pegar-resposta", {
          id_paciente: id,
          id_pergunta: 9,
        });

        setPesoHabitual(parseFloat(data.replace(",", ".")));
      }
    } catch (error) {
      console.error("Ocorreu um erro:", error.message);
    }
  }

  async function getSubstanciaMedicamentos() {
    try {
      const { data } = await api.get("/substancia");

      setSubstanciaList(data);
    } catch (error) {
      console.error("Ocorreu um erro:", error.message);
    }
  }

  async function getMedicamentos(substancia) {
    try {
      const { data } = await api.get(`/medicamentos/${substancia}`);

      // const response = await api.get(`/substancia/${idConsultaEvolucao}`);

      setMedicamentosList(data);
    } catch (error) {
      console.error("Ocorreu um erro:", error.message);
    }
  }

  const clearMedicamento = () => {
    setMedicamentosList([]);
    setPrescricaoMedicamentosState((prevState) => ({
      ...prevState,
      nomeMedicamento: "",
    }));
  };

  const clearApresentacao = () => {
    setApresentacaoList([]);
    setPrescricaoMedicamentosState((prevState) => ({
      ...prevState,
      apresentacao: "",
    }));
  };
  async function getApresentacao(medicamento) {
    try {
      const { data } = await api.get(`/apresentacao/${medicamento}`);

      setApresentacaoList(data);
    } catch (error) {
      console.error("Ocorreu um erro:", error.message);
    }
  }

  const handleSubstancia = (selecionado) => {
    if (selecionado) {
      const substancia = selecionado.no_substancia;

      setPrescricaoMedicamentosState((prevState) => ({
        ...prevState,
        substancia: substancia,
      }));

      getMedicamentos(substancia);
    } else {
      clearMedicamento();
      clearApresentacao();
    }
  };

  const handlePeriodoTratamento = (value) => {
    const periodoTratamento = value;
    setPrescricaoMedicamentosState((prevState) => ({
      ...prevState,
      periodoTratamento: periodoTratamento,
    }));

    if (periodoTratamento === "continuo") {
      setPrescricaoMedicamentosState((prevState) => ({
        ...prevState,
        duracaoTratamento: "",
      }));
    }
  };

  const handleMedicamento = (selecionado) => {
    clearApresentacao();

    if (selecionado) {
      const medicamento = selecionado.no_descricao;

      setPrescricaoMedicamentosState((prevState) => ({
        ...prevState,
        nomeMedicamento: medicamento,
      }));

      getApresentacao(medicamento);
    }
  };

  const handleApresentacao = (selecionado) => {
    if (selecionado) {
      setPrescricaoMedicamentosState((prevState) => ({
        ...prevState,
        apresentacao: selecionado.no_apresentacao,
      }));

      setPrescricaoMedicamentosState((prevState) => ({
        ...prevState,
        idMedicamento: selecionado.co_id,
      }));
    }
  };

  const handleCheckedField = (e, field) => {
    const { value, checked } = e.target;

    if (dadosIniciaisState[field] === undefined) {
      dadosIniciaisState[field] = [];
    }
    if (checked) {
      setDadosIniciaisState((prevState) => ({
        ...prevState,
        [field]: [...dadosIniciaisState[field], value],
      }));
    } else {
      setDadosIniciaisState((prevState) => ({
        ...prevState,
        [field]: dadosIniciaisState[field].filter((e) => e !== value),
      }));
    }
  };

  const handleExamesPredefinidosOptions = (val) => {
    const value = val;
    if (value === "") {
      setDadosIniciaisState((prevState) => ({
        ...prevState,
        examesPredefinidosExamesEProcedimentos: [],
      }));
    } else if (value === "2") {
      setDadosIniciaisState((prevState) => ({
        ...prevState,
        examesPredefinidosExamesEProcedimentos: examesPredefinidosList.map(
          (exame) => exame.value
        ),
      }));
    } else if (value === "3") {
      setDadosIniciaisState((prevState) => ({
        ...prevState,
        examesPredefinidosExamesEProcedimentos: ["1", "4", "5", "25", "26"],
      }));
    }

    setDadosIniciaisState((prevState) => ({
      ...prevState,
      examesPredefinidosSelect: value,
    }));
  };

  const handleSalvarTudo = () => {
    handleSubmit("salvar-tudo");
  };

  async function atualizaStatusConsulta(
    id_consulta_evolucao,
    id_status,
    id_vinculo
  ) {
    try {
      if (isMultidisciplinar) {
        //Atualizar consulta multidisciplinar
        await api.put("/consulta-multi-update", {
          id_consulta_evolucao,
          id_status,
          id_vinculo,
        });
      } else {
        await api.put("/consulta/", {
          id_consulta_evolucao,
          id_status,
          id_vinculo,
        });
      }
    } catch (error) {
      console.error("Ocorreu um erro:", error.message);
    }
  }

  const handleRemoverMedicamento = async () => {
    try {
      await api.post(`/prescricao-medicamentos/delete/`, {
        id_paciente: id,
        id_vinculo: vinculo.id,
      });
    } catch (error) {
      console.error("Ocorreu um erro:", error.message);
      return;
    }

    handleClose();
    setMedicamentos(
      medicamentos.filter(
        (medicamento) =>
          medicamento.idMedicamento !== removerMedicamento.idMedicamento
      )
    );
  };

  const handleEditarMedicamento = async (medicamento) => {
    setTextoBotaoMedicamento("Editar medicamento");
    setEditarMedicamento(medicamento);
    setModoEdicao(true);

    const duracao = medicamento.duracaoTratamento.split("-")[0];
    const periodo = medicamento.duracaoTratamento.split("-")[1];

    setPrescricaoMedicamentosState((prevState) => ({
      ...prevState,
      substancia: medicamento.substancia,
      nomeMedicamento: medicamento.nomeMedicamento,
      apresentacao: medicamento.apresentacao,
      idMedicamento: medicamento.idMedicamento,
      posologia: medicamento.posologia,
      observacao: medicamento.observacao,
      duracaoTratamento: duracao,
      periodoTratamento: periodo,
    }));
  };

  async function handleSubmit(event, finalizaConsulta = false) {
    if (event === "salvar-tudo") {
      try {
        if (!dadosIniciaisState.tipoDisfuncao.includes("118")) {
          dadosIniciaisState.disfuncaoAutonomicaOutra = "";
        }

        prescricaoMedicamentosState.idPaciente = id;
        prescricaoMedicamentosState.idVinculo = vinculo.id;
        prescricaoMedicamentosState.medicamentosAdicionados = medicamentos;

        await requestAnamneseNeurologica(dadosIniciaisState);

        await requestExameNeurologicoMotor(dadosIniciaisState);
        await requestAnamneseDadosGerais(dadosIniciaisState);
        await requestExameNeurologicoNervosCranianos(dadosIniciaisState);
        await requestExameNeurologicoSensibilidade(dadosIniciaisState);
        await requestDiagnosticoELA(dadosIniciaisState);
        await requestCondutaConclusaoEncaminhamentos(dadosIniciaisState);
        await requestPrescricaoMedicamento(prescricaoMedicamentosState);
        await requestExamesEProcedimentos(dadosIniciaisState);

        console.log("finalizaConsulta", finalizaConsulta);
        console.log("finalizaConsulta", idConsultaEvolucao);

        if (finalizaConsulta && idConsultaEvolucao) {
          const FINALIZADA = 3;

          // Para finalizar a consulta todos os participantes
          // devem ter finalizado

          atualizaStatusConsulta(idConsultaEvolucao, FINALIZADA, vinculo.id);

          setOpenFinalizar(true);
        } else {
          setOpenSalvar(true);
        }
      } catch (error) {
        console.error("Ocorreu um erro:", error.message);
      } finally {
        return;
      }
    }

    event.preventDefault();

    let response = null;

    switch (event.nativeEvent.submitter.name) {
      case "anamneseNeurologica":
        response = await requestAnamneseNeurologica(dadosIniciaisState);
        break;
      case "dadosGerais":
        response = await requestAnamneseDadosGerais(dadosIniciaisState);
        break;
      case "nervosCranianos":
        response = await requestExameNeurologicoNervosCranianos(
          dadosIniciaisState
        );
        break;
      case "motor":
        response = await requestExameNeurologicoMotor(dadosIniciaisState);
        break;
      case "sensibilidade":
        if (!dadosIniciaisState.tipoDisfuncao.includes("118")) {
          dadosIniciaisState.disfuncaoAutonomicaOutra = "";
        }
        response = await requestExameNeurologicoSensibilidade(
          dadosIniciaisState
        );
        break;
      case "laboratorial":
        response = await requestExamesEProcedimentos(dadosIniciaisState);
        break;
      case "outrosExames":
        response = await requestExamesEProcedimentos(dadosIniciaisState);
        break;
      case "diagnosticoELA":
        response = await requestDiagnosticoELA(dadosIniciaisState);
        break;
      case "prescricaoMedicamentos":
        prescricaoMedicamentosState.idPaciente = id;
        prescricaoMedicamentosState.idVinculo = vinculo.id;
        prescricaoMedicamentosState.medicamentosAdicionados = medicamentos;

        response = await requestPrescricaoMedicamento(
          prescricaoMedicamentosState
        );
        break;
      case "condutaConclusaoEncaminhamentos":
        response = await requestCondutaConclusaoEncaminhamentos(
          dadosIniciaisState
        );
        break;
      default:
      // code block
    }
    if (response) {
      setExpanded(false);
      setOpenSalvar(true);
    }
  }

  function adicionarMedicamento() {
    if (editarMedicamento.length !== 0) {
      setMedicamentos(
        medicamentos.filter(
          (med) => med.idMedicamento !== editarMedicamento.idMedicamento
        )
      );
      setEditarMedicamento({});
    }

    setMedicamentos((prevState) => [
      ...prevState,
      {
        substancia: prescricaoMedicamentosState.substancia,
        nomeMedicamento: prescricaoMedicamentosState.nomeMedicamento,
        apresentacao: prescricaoMedicamentosState.apresentacao,
        duracaoTratamento:
          prescricaoMedicamentosState.duracaoTratamento +
          "-" +
          prescricaoMedicamentosState.periodoTratamento,
        posologia: prescricaoMedicamentosState.posologia,
        observacao: prescricaoMedicamentosState.observacao,
        idMedicamento: prescricaoMedicamentosState.idMedicamento,
      },
    ]);

    setPrescricaoMedicamentosState((prevState) => ({
      ...prevState,
      substancia: "",
      nomeMedicamento: "",
      apresentacao: "",
      idMedicamento: 0,
      posologia: "",
      observacao: "",
      duracaoTratamento: "",
      periodoTratamento: "dias",
    }));

    setTextoBotaoMedicamento("Adicionar novo medicamento +");
    setModoEdicao(false);
  }

  const RenderDiagnosticoEla = () => (
    <DiagnosticoEla
      expanded={expanded}
      handleChangePanel={handleChangePanel}
      onSubmit={handleSubmit}
      data={dadosIniciaisState}
      setData={setDadosIniciaisState}
      diagnosticoEhELAOptions={diagnosticoEhELAOptions}
      CIDList={CIDList}
      classificacaoKingsCollegeOptions={classificacaoKingsCollegeOptions}
      atualizarEscalaFuncional={atualizarEscalaFuncional}
      escalaFuncional={escalaFuncional}
      causaOptions={causaOptions}
      localDeInicioOptions={localDeInicioOptions}
      fenotipoDeInicioOptions={fenotipoDeInicioOptions}
      idConsultaEvolucao={idConsultaEvolucao}
    />
  );

  if (loading) {
    return <Loading />;
  }

  return (
    <Box>
      <ButtonGoBack goBack={-1} />

      <CardPaciente id={id} />

      <Box mb="50px">
        <Stack
          direction="row"
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: "16px",
            flexWrap: "wrap",
            mb: "16px",
          }}
        >
          <Stack>
            <Typography style={styles.formTitle}>
              Consulta em andamento
            </Typography>
            <Typography style={styles.subtitle}>
              Presencial | Multidisciplinar
            </Typography>
          </Stack>

          <TimerComponent
            hours={hours}
            minutes={minutes}
            seconds={seconds}
            setOpenCancelar={setOpenCancelar}
            handleSalvarTudo={handleSalvarTudo}
            handleOpen={handleOpen}
          />
        </Stack>
        <AnamneseGeral
          expanded={expanded}
          handleChangePanel={handleChangePanel}
          onSubmit={handleSubmit}
          data={dadosIniciaisState}
          setData={setDadosIniciaisState}
          pesoHabitual={pesoHabitual}
          simOuNaoOptions={simOuNaoOptions}
          statusCognitivoOptions={statusCognitivoOptions}
        />

        {isConsultaRotina && RenderDiagnosticoEla()}

        <AnamneseNeurologica
          expanded={expanded}
          handleChangePanel={handleChangePanel}
          onSubmit={handleSubmit}
          data={dadosIniciaisState}
          setData={setDadosIniciaisState}
          ventilacaoNaoInvasivaDuracaoOptions={
            ventilacaoNaoInvasivaDuracaoOptions
          }
          showTabs={isConsultaRotina}
          valueTab={value}
          onChangeTab={handleChange}
          traqueostomiaProcedimentoOptions={traqueostomiaProcedimentoOptions}
          handleCheckedField={handleCheckedField}
          multidisciplinaridadeTipoOptions={multidisciplinaridadeTipoOptions}
          tipoProcedimentoOptions={tipoProcedimentoOptions}
          simOuNaoOptions={simOuNaoOptions}
          sinaisSintomasList={sinaisSintomasList}
        />

        <ExameNeurologico
          expanded={expanded}
          handleChangePanel={handleChangePanel}
          tabOnChange={handleChange}
          tabValue={value}
          onSubmit={handleSubmit}
          data={dadosIniciaisState}
          setData={setDadosIniciaisState}
          pesoHabitual={pesoHabitual}
          simOuNaoOptions={simOuNaoOptions}
          statusCognitivoOptions={statusCognitivoOptions}
          presenteAusenteOptions={presenteAusenteOptions}
          reflexoNauseosoOptions={reflexoNauseosoOptions}
          musculaturaFacialOptions={musculaturaFacialOptions}
          handleCheckedField={handleCheckedField}
          masseterOptions={masseterOptions}
          linguaMovimentacaoOptions={linguaMovimentacaoOptions}
          linguaAtrofiaOptions={linguaAtrofiaOptions}
          veloPalatinoOptions={veloPalatinoOptions}
          fasciculacoesOndeOptions={fasciculacoesOndeOptions}
          tonusMuscularOptions={tonusMuscularOptions}
          reflexoOptions={reflexoOptions}
          avaliacaoSegmentarOptions={avaliacaoSegmentarOptions}
          disfuncaoAutonomicaOptions={disfuncaoAutonomicaOptions}
        />

        <ExamesProcedimentos
          expanded={expanded}
          handleChangePanel={handleChangePanel}
          value={value}
          handleChange={handleChange}
          onSubmit={handleSubmit}
          data={dadosIniciaisState}
          setData={setDadosIniciaisState}
          handleExamesPredefinidosOptions={handleExamesPredefinidosOptions}
          examesPredefinidosOptions={examesPredefinidosOptions}
          handleCheckedField={handleCheckedField}
          examesPredefinidosList={examesPredefinidosList}
        />

        {!isConsultaRotina && RenderDiagnosticoEla()}

        <PrescricaoMedicamentos
          expanded={expanded}
          handleChangePanel={handleChangePanel}
          handleSubmit={handleSubmit}
          substanciaList={substanciaList}
          prescricaoMedicamentosState={prescricaoMedicamentosState}
          handleSubstancia={handleSubstancia}
          modoEdicao={modoEdicao}
          medicamentosList={medicamentosList}
          handleMedicamento={handleMedicamento}
          apresentacaoList={apresentacaoList}
          handleApresentacao={handleApresentacao}
          setPrescricaoMedicamentosState={setPrescricaoMedicamentosState}
          handlePeriodoTratamento={handlePeriodoTratamento}
          periodoTratamentoOptions={periodoTratamentoOptions}
          adicionarMedicamento={adicionarMedicamento}
          textoBotaoMedicamento={textoBotaoMedicamento}
          medicamentos={medicamentos}
          editarMedicamento={editarMedicamento}
          setOpenRemoverMedicamento={setOpenRemoverMedicamento}
          setRemoverMedicamento={setRemoverMedicamento}
          handleEditarMedicamento={handleEditarMedicamento}
        />

        <Condutas
          expanded={expanded}
          handleChangePanel={handleChangePanel}
          handleSubmit={handleSubmit}
          data={dadosIniciaisState}
          setData={setDadosIniciaisState}
        />
      </Box>

      <ModalDialogs
        open={open}
        onClose={handleClose}
        onActionSecondary={handleClose}
        onActionPrimary={handleFinalizar}
        modalType="warning"
        title={
          <>
            <IconWallet /> Finalizar consulta
          </>
        }
        body="Você realmente deseja finalizar essa consulta?"
        secondaryButtonText="Não"
        primaryButtonText="Sim"
      />

      <ModalDialogs
        open={openCancelar}
        onClose={handleClose}
        onActionSecondary={handleClose}
        onActionPrimary={handleCancelarConsulta}
        modalType="error"
        title={
          <>
            <IconWallet /> Cancelar consulta
          </>
        }
        body="Você realmente deseja cancelar essa consulta?"
        secondaryButtonText="Não"
        primaryButtonText="Sim"
      />

      <ModalDialogs
        open={openFinalizar}
        onClose={() => {
          handleClose();
          handleRedirect();
        }}
        onActionSecondary={Resumo}
        onActionPrimary={homeIn}
        modalType="success"
        title={
          <>
            <IconWallet /> Consulta finalizada
          </>
        }
        body="A consulta foi finalizada com sucesso"
        secondaryButtonText="Resumo da consulta"
        primaryButtonText="Home-in"
      />

      <ModalDialogs
        open={openSalvar}
        onClose={handleClose}
        onActionSecondary={handleClose}
        onActionPrimary={homeIn}
        modalType="success"
        title={
          <>
            <IconWallet /> Dados salvos
          </>
        }
        body={
          <Box sx={{ width: { xs: "100%", sm: "400px" } }}>
            Dados salvos com sucesso
          </Box>
        }
        secondaryButtonText="Permanecer na consulta"
        primaryButtonText="Home-in"
      />

      <ModalDialogs
        open={openRemoverMedicamento}
        onClose={handleClose}
        onActionSecondary={handleClose}
        onActionPrimary={handleRemoverMedicamento}
        modalType="warning"
        title={
          <>
            <IconTrash /> Remover medicamento
          </>
        }
        body="Você realmente deseja remover esse medicamento?"
        secondaryButtonText="Não"
        primaryButtonText="Sim"
      />
      {!!snackbar && (
        <Snackbar
          open
          onClose={() => setSnackbar(null)}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <Alert {...snackbar} onClose={() => setSnackbar(null)} />
        </Snackbar>
      )}
    </Box>
  );
}
